import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {type IAsset} from '../schema';
import {assetNotCheckedOut} from './assetNotCheckedOut';

export const canReimportAsset = (asset?: IAsset): boolean => {
	if (asset == null) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	if (!assetNotCheckedOut(asset)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.REIMPORT,
	});
};
